"use client";
import { Providers } from "@forestsync/ui";
import { UiModeProvider } from "@/components/ui-mode";
import { AnalyticsProvider } from "@/components/analytics/AnalyticsProvider";
import type { UiMode } from "@forestsync/db";

export default function UIProvidersClient({
  children,
  initialMode,
  userId,
}: {
  children: React.ReactNode;
  initialMode: UiMode;
  userId: string | null;
}) {
  return (
    <Providers>
      <UiModeProvider initialMode={initialMode}>
        <AnalyticsProvider userId={userId}>
          {children}
        </AnalyticsProvider>
      </UiModeProvider>
    </Providers>
  );
}
